import {Injectable} from "@angular/core";
import {GenericService} from "../../core/commons/generic.service";
import {Profile} from "../domain/profile";
import {QueryOptions} from "../../core/commons/query.options";
import {AuthHttp} from "angular2-jwt";
import {AuthService} from "../../core/security/auth.service";
import {RequestMethod} from "@angular/http";
import {Observable} from "rxjs/Observable";
import { UserPreferences } from "app/fiscalia/domain/userPreferences";

@Injectable()
export class ProfileService extends GenericService<Profile> {

    private profileUrl = "/profiles";


    constructor(authService: AuthService) {
        super(authService)
    }

    protected valueToEntity(value: Object): Profile {
        return new Profile(value);
    }

    protected getResourcePath(): string {
        return this.profileUrl;
    }

    getDefaultQueryOptions(): QueryOptions {
        return new QueryOptions();
    }

    getByUserId(id :number): Observable<Profile>{
        let req = this.buildRequest(RequestMethod.Get);
        return this.authService.authRequest(this.baseUrl + this.profileUrl + "/user/" + id.toString(), req)
            .map(res => this.valueToEntity(res.json()));
    }

    getProfilePhotoByUserId(id: number): Observable<Profile> {
        const req = this.buildRequest(RequestMethod.Get);
        return this.authService.authRequest(this.baseUrl + this.profileUrl + '/user/' + id.toString() + '/photo', req)
            .map(res => this.valueToEntity(res.json()));
    }

    getUserPreferences(): Observable<UserPreferences> {
        const req = this.buildRequest(RequestMethod.Get);
        return this.authService.authRequest(this.baseUrl + "/userPreferences", req)
            .map(res => new UserPreferences(res.json()));
    }

    updateUserPreferences(userPreferences: UserPreferences): Observable<UserPreferences> {
        const req = this.buildRequest(RequestMethod.Put, JSON.stringify(userPreferences));
        return this.authService.authRequest(this.baseUrl + "/userPreferences", req)
            .map(res => new UserPreferences(res.json()));
    }


}



// WEBPACK FOOTER //
// ./src/app/profile/service/profile.service.ts